import { z } from "zod";
import { TypeEncoding } from "~/services/datastore";
import type { Option } from "./types";
import { createErrorMap } from "./utils";

export const typeEncodingOptions: Option[] = Object.values(TypeEncoding).map(
  (value) => ({
    label: value,
    value,
  }),
);

export const requiredTypeEncodingSchema = z.nativeEnum(TypeEncoding, {
  errorMap: createErrorMap({
    invalid_type(issue) {
      if (issue.received === z.ZodParsedType.null) {
        return "Field is required";
      } else {
        return "Unexpected value";
      }
    },
    invalid_enum_value: "Unexpected value",
  }),
});

export const optionalTypeEncodingSchema = requiredTypeEncodingSchema.nullable();
